import ipfs from "decentralized/Ipfs.js";
import {decryptProject} from 'crypto/decryptProject.js';
import ethereum from 'decentralized/ethereum.js';
import EncryptedIpfs from "decentralized/guilds/EncryptedIpfs.js"
import {INSTRUMENT_TYPE_TO_NAME} from 'constants/instrument-types.js';
import {MULTI_FREEZE} from 'constants/track-types.js';
import Sample from 'repos/Sample.js';


export const loadProject = async (project) => {
    let data = await decryptProject(project);
    let subs = [];
    for (let sub of data.subSequences) {
        let tracks = await getTracks(sub);
        subs.push(tracks);
    }
    return subs;
};

const getTracks = async (sub) => {
    let tracks = [];
    let i = 0;
    for (let trackData of sub.tracksData) {
        let {type, instrumentType, presetName, samplers} = trackData;
        let sampleIds = Object.keys(samplers);
        let track = {
            type,
            instrumentType,
            name: presetName || INSTRUMENT_TYPE_TO_NAME[instrumentType]
        };
        if (type === MULTI_FREEZE) {
            track.name = 'Multi Freeze';
        }
        if (sampleIds.length > 0) {
            let sample = new Sample(sampleIds[0]);
            await sample.fetchMetadata();
            track.name = sample.name;
            track.sample = sample;
        }
        track.patterns = sub.tracks[i];
        track.patternParameters = sub.tracksPatterns[i];
        track.trackEffects = sub.tracksEffectsChains[i][0];
        track.trackMidiEffects = sub.tracksMidiEffects[i];
        track.trackLiveEffects = sub.tracksLiveEffects[i];
        track.parameters = sub.tracksParameters[i];
        track.trackData = sub.tracksData[i];
        track.envelopes = sub.envelopes;
        track.lfos = sub.lfos;
        tracks.push(track);
        i++;
    }
    return tracks;
};
